import Vue from 'vue';
import ToolBar from "../../parts/ToolBar.vue";
export default Vue.extend({
    components: { ToolBar },
    name: "LessonLevel",
    data() {
        return {
            items: [
                {
                    image: 'image_lesson_card1.png',
                    title: this.$t('lesson.level_beginner_title'),
                    setup: this.$t('lesson.level_beginner_setup'),
                    message: this.$t('lesson.level_beginner_message'),
                    to: '/lesson/beginner',
                },
                {
                    image: 'image_lesson_card2.png',
                    title: this.$t('lesson.level_login_title'),
                    setup: this.$t('lesson.level_login_setup'),
                    message: this.$t('lesson.level_login_message'),
                    to: '/lesson/login',
                },
                {
                    image: 'image_lesson_card3.png',
                    title: this.$t('lesson.level_user_title'),
                    setup: this.$t('lesson.level_user_setup'),
                    message: this.$t('lesson.level_user_message'),
                    to: '/lesson/user',
                },
            ],
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/lesson/LessonLevel.vue
// module id = 639
// module chunks = 1